import {
  RENTAL_INTRO_STEP,
  RENTAL_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Rental";

import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";

export function mapFromCommerceRental(data: Record<string, any>): FormState {
  return {
    [RENTAL_INTRO_STEP.id]: {
      monthlyRent: data.monthlyRent,
      postNumber: data.address.zipCode,
      validPostNumber: true,
      city: data.address.city ?? undefined,
      huseierneMembershipStatus: data.huseierneMembershipStatus,
    },
    [RENTAL_PRICE_STEP.id]: {
      coverage: data.coverageGroup,
    },
  };
}
